import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chart-sankey', 'ChartSankey', [["path",{"d":"M3 3v18h18"}],["path",{"d":"M3 6h18"}],["path",{"d":"M3 8c10 0 8 9 18 9"}]]);